export class RequestResultSettingDto {
    requestResultSettingId: number;
    clientId: number;
    requestTypeId: number;
    nextRequestStatusId: number;
    requestResultId: number;
    externalStatus: string;
}
